









import { Component, Prop, Vue } from 'vue-property-decorator';
import { Warning } from '@/pages/profile/components';
import MentoringRequestList from '../../requestslist';
import { REQUEST_WARNING } from '@/pages/profile/modules';
import { IMentoringWorkingRequests, Requests } from './types';

@Component({
  components: {
    Warning,
    MentoringRequestList,
  },
})
export default class MentoringCurrentRequests
  extends Vue
  implements IMentoringWorkingRequests {
  @Prop({ type: Array, default: () => [] })
  readonly items!: Requests;

  public warningText: string = REQUEST_WARNING;

  get workingItems(): Requests {
    // Здесь фильтруем по завершенным запросам
    return this.items.filter((item) => item.status === '2');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/views/workingrequests/MentoringWorkingRequests.vue